export function formatDate(date: Date): string {
  return date.toISOString().split("T")[0];
}

/**
 * Expand the pricecurve "from" date to show a wider range.
 * If the search start date is >31 days away, go back 1 month.
 * Otherwise use tomorrow (no point showing past dates).
 * Matches Sunrise logic in wegde-ibe/src/sagas/priceCurve.ts
 */
export function calculatePriceCurveFromDate(fromDate: string): string {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  const searchFrom = new Date(fromDate);
  const diffDays =
    (searchFrom.getTime() - tomorrow.getTime()) / (1000 * 60 * 60 * 24);

  if (diffDays > 31) {
    const expanded = new Date(searchFrom);
    expanded.setMonth(expanded.getMonth() - 1);
    return formatDate(expanded);
  }
  return formatDate(tomorrow);
}

/**
 * Expand the pricecurve "to" date by adding 1 month.
 * Matches Sunrise logic in wegde-ibe/src/sagas/priceCurve.ts
 */
export function calculatePriceCurveToDate(toDate: string): string {
  const searchTo = new Date(toDate);
  searchTo.setMonth(searchTo.getMonth() + 1);
  return formatDate(searchTo);
}
